import * as React from "react";
import ReactModal from "react-modal";
import IconButton from "./IconButton";
import Gear from "./icons/Gear";
import SettingsPane from "./SettingsPane";
import { Tooltip } from "react-tooltip";
import { AppStateContext } from "./AppStateProvider";
var contentStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "min(640px, 92vw)",
    transform: "translate(-50%, -50%)",
    padding: "0",
};
var SettingsButton = function () {
    var _a = React.useState(false), modalOpen = _a[0], setModalOpen = _a[1];
    var _b = React.useContext(AppStateContext), state = _b.state, updateState = _b.updateState;
    return (React.createElement(React.Fragment, null,
        React.createElement(Tooltip, { id: "settingsTip", place: "top" }),
        React.createElement(IconButton, { onClick: function () { return setModalOpen(true); }, "aria-label": "Settings", "data-tooltip-id": "settingsTip", "data-tooltip-content": "Change user interface settings" },
            React.createElement(Gear, { width: "2em" })),
        React.createElement(ReactModal, { isOpen: modalOpen, onRequestClose: function () { return setModalOpen(false); }, shouldCloseOnOverlayClick: true, shouldCloseOnEsc: true, style: { content: contentStyle } },
            React.createElement("div", { className: "flex max-h-[85dvh] flex-col" },
                React.createElement("div", { className: "flex items-start justify-between gap-3 border-b border-[var(--border-subtle)] p-4 sm:p-5" },
                    React.createElement("div", null,
                        React.createElement("h2", { className: "m-0 text-lg font-bold tracking-tight text-[var(--text-primary)]" }, "Interface settings"),
                        React.createElement("p", { className: "m-0 mt-1 text-xs text-[var(--text-secondary)]" }, "Personal display, gameplay and accessibility preferences.")),
                    React.createElement("button", { type: "button", "aria-label": "Close", className: "sj-btn sj-btn-ghost !min-h-[36px] !px-3 !text-[var(--text-primary)]", onClick: function () { return setModalOpen(false); } }, "\u2715")),
                React.createElement("div", { className: "overflow-y-auto p-4 sm:p-5" },
                    React.createElement(SettingsPane, { settings: state.settings, onChangeSettings: function (settings) {
                            return updateState({ settings: settings });
                        } })),
                React.createElement("div", { className: "border-t border-[var(--border-subtle)] p-3 text-right sm:p-4" },
                    React.createElement("button", { type: "button", className: "sj-btn sj-btn-primary !min-h-[40px]", onClick: function () { return setModalOpen(false); } }, "Done"))))));
};
export default SettingsButton;
